import { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { getRole } from '@domains/user/store/slices/user-slice/user-slice';

interface RolesGuardProps {
  roles: string[];
  children: ReactNode;
}

export const RolesGuard = ({ roles, children }: RolesGuardProps) => {
  const userRoles = useSelector(getRole);

  const hasPermission = roles.some(role => userRoles.includes(role));

  if (!hasPermission) return null;

  return <>{children}</>;
};
